/**
 * Gössl Theme 2026 — title reveals (r33: IntersectionObserver, no GSAP).
 * Same quiet language as r11: whole title fades up ~14px, once.
 * The hidden state only exists while html.g26-anim is set by this script,
 * so no-JS and reduced-motion users always see content immediately.
 */
(function() {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var TITLES = [
    '.g26-slider__title',
    '.g26-colhead__title',
    '.g26-hero__title',
    '.g26-hero__kicker',
    '.g26-pdp__title',
    '.g26-search__popular-title',
    '.section-header__line',
    '.goessl-collection-hero__title',
    '.goessl-collection-hero__preheading',
    '.newsletter-cta__heading',
    '[data-animate="fade-up"]'
  ].join(', ');

  function init() {
    var els = document.querySelectorAll(TITLES);
    if (!els.length) return;
    document.documentElement.classList.add('g26-anim');
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function(el) { el.classList.add('g26-reveal'); io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
